import React, { useState, useMemo } from "react";
import CompassLinks from "../components/compassLinks";
import { calculateUNOSRollout } from "../utils/unos";

const bg = "/P1010053.jpg";

function CompassPage() {
  const [latitude, setLatitude] = useState("34.0");
  const [tas, setTas] = useState("100");
  const [turnDegrees, setTurnDegrees] = useState("90");

  const standardRateTurn = useMemo(() => {
    const tasNum = Number(tas);
        if (!Number.isFinite(tasNum) || tasNum <= 0) {
          return { 
            degrees: 0,
            text: "Invalid TAS" 
          };
        }
    const degrees = (tasNum / 10) + 5;

    return {
      degrees,
      text: `Standard rate turn at ${tasNum} KTAS is approximately ${degrees.toFixed(1)}° bank`
    }
  }, [tas]);

  const timedTurn = useMemo(() => {
    const deg = Number(turnDegrees);
    const rate = 3; // standard rate turn is approximately 3° per second
    const tasNum = Number(tas);

      if (!Number.isFinite(deg) || !Number.isFinite(rate) || rate <= 0) {
        return {
          seconds: 0,
          text: "Enter valid values"
        };
      }

      const seconds = deg / rate;

      return {
          seconds,
          text: `Turn ${deg}° at Standard Rate takes ${seconds.toFixed(1)} seconds`
        };
      }, [turnDegrees, standardRateTurn.degrees, tas]); 

  const unos360 = useMemo(() => {
    return calculateUNOSRollout(360, latitude, tas);
  }, [latitude, tas]);

  const unos180 = useMemo(() => {
    return calculateUNOSRollout(180, latitude, tas);
  }, [latitude, tas]);

  return (

    <article className="App-article"
          style={{
          minHeight: "100vh",
          backgroundImage: `linear-gradient(rgba(0,0,0,0.15), rgba(0,0,0,0.15)), url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
    <div style={{ padding: "12px" }}>

      {/* UNOS CALCULATOR */}
      <div className="unos-global-box">
        <div className="unos-title">UNOS: Undershoot North, Overshoot South</div>
        
        <div style={{display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
           <label style={{fontWeight: "bold", fontSize: "16px"}}>Latitude</label>
        
        <input
            style={{ fontSize: "16px", padding: "4px 6px", fontWeight: "bold", width: "100px" }}
              value={latitude}
              onChange={(e) => setLatitude(e.target.value)}
              placeholder="Enter latitude"
            />

          <label style={{fontWeight: "bold", fontSize: "16px"}}>TAS</label>
          <input
            style={{ fontSize: "16px", padding: "4px 6px", fontWeight: "bold", width: "100px" }}
              value={tas}
              onChange={(e) => setTas(e.target.value)}
              placeholder="Enter TAS"
            />
        
        </div>
        {/* RESULTS */}
        <div style={{ marginBottom: "6px", fontSize: "16px", fontWeight: "bold" }}>{unos360.text}</div>
        <div>{unos180.text}</div>
      </div>

      
      <div 
        style={{
            marginTop: "20px",
            padding: "12px 16px",
            backgroundColor: "rgba(255,255,255,0.8)",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            textAlign: "left",
            maxWidth: "650px",
          }}> 

      <CompassLinks />
      </div>

      <div 
        style={{
            marginTop: "20px",
            padding: "12px 16px",
            backgroundColor: "rgba(255,255,255,0.8)",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            textAlign: "left",
            maxWidth: "450px",
          }}> 

       <div style={{ fontWeight: "bold" }}>
        Standard Rate Turns
        </div>
        
        <div style={{ marginTop: "8px" }}>
          {standardRateTurn.text}
          </div>
        
        <div style={{ fontSize: "14px", marginTop: "6px", fontWeight: "bold" }}>
          Formula: (TAS / 10) + 5
        </div>

        {/* separator */}
        <hr style={{ margin: "10px 0", opacity: 0.9 }} />


       <div style={{ fontWeight: "bold", fontSize: "16px" }}>
        ANDS (Acceleration North, Deceleration South)
        </div>
        
        <div style={{ marginTop: "8px", fontWeight: "bold" }}>
          East/West headings only
          </div>
        
        <div 
        style={{ 
          fontSize: "14px", 
          marginTop: "8px", 
          fontWeight: "bold" ,
          lineHeight: "1.4"
          }}>
          Acceleration → initially turns to the North<br/>
          Deceleration → initially turns to the South
        </div>

          {/* separator */}
        <hr style={{ margin: "10px 0", opacity: 0.9 }} />
        {/* ---------- TIMED TURNS ---------- */}
        <hr style={{ margin: "10px 0", opacity: 0.9 }} />
        <div style={{ fontWeight: "bold" }}>
        Timed Turns: 3° per second if using a standard rate turn
      </div>
          <br></br>
      <div style={{ fontWeight: "bold" }}>
        Timed Turns: 3° per second at Standard Rate, requires 120 seconds to complete a 360° turn
      </div>
      <br></br>
      <div style={{ fontWeight: "bold" }}>
        Enter degrees to turn:
      </div>

      <div style={{ marginTop: "6px" }}>
        <input
          style={{
            fontSize: "18px",
            padding: "4px 6px",
            width: "50px",
            fontWeight: "bold"
          }}
          value={turnDegrees}
          onChange={(e) => setTurnDegrees(e.target.value)}
          placeholder="Degrees"
        />
      </div>
      <div style={{ marginTop: "8px", fontSize: "18px" }}>
        {timedTurn.text}
      </div>

      <div style={{ fontSize: "16px", marginTop: "4px" }}>
        Time = Degrees ÷ Rate
      </div>

      </div>
      </div>
   
    </article>
  );
}

export default CompassPage;